import React from "react";
import { RefreshCw, DollarSign, Clock, AlertTriangle, CheckCircle, XCircle } from "lucide-react";

export default function CancellationRefunds() {

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-950 text-white relative overflow-hidden">
      {/* Animated Gradient Orbs */}
      <div className="absolute -top-20 -left-20 w-72 h-72 bg-green-600/30 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-emerald-600/30 rounded-full blur-3xl animate-ping"></div>

      <div className="relative max-w-4xl mx-auto p-8 space-y-8 z-10">

        {/* Header */}
        <div className="text-center">
          <h1 className="text-4xl font-extrabold flex items-center justify-center gap-3 mb-4">
            <RefreshCw className="w-10 h-10 text-green-500 animate-bounce" />
            Cancellation & Refunds
          </h1>
          <p className="text-gray-400 text-lg">Learn about our cancellation and refund policies</p>
        </div>

        {/* Content Sections */}
        <div className="space-y-6">

          {/* Cancellation Policy */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-green-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <XCircle className="w-6 h-6 text-green-400" /> Cancellation Policy
            </h2>
            <div className="space-y-3 text-gray-300">
              <p><strong>Free Cancellation:</strong> You can cancel your subscription at any time without penalty.</p>
              <p><strong>Immediate Effect:</strong> Cancellation takes effect immediately upon confirmation.</p>
              <p><strong>No Hidden Fees:</strong> We don't charge any cancellation fees or penalties.</p>
            </div>
          </div>

          {/* Refund Policy */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-emerald-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <DollarSign className="w-6 h-6 text-green-400" /> Refund Policy
            </h2>
            <div className="space-y-4 text-gray-300">
              <div className="space-y-2">
                <h3 className="text-lg font-medium text-green-400">Eligibility for Refunds:</h3>
                <p>• Unused portion of prepaid subscriptions</p>
                <p>• Technical issues preventing service access for more than 24 hours</p>
                <p>• Accidental duplicate charges</p>
                <p>• Service not as described</p>
              </div>
              <div className="space-y-2">
                <h3 className="text-lg font-medium text-red-400">Non-Refundable:</h3>
                <p>• Partial months of service already used</p>
                <p>• Premium features already consumed</p>
                <p>• Gift subscriptions after redemption</p>
              </div>
            </div>
          </div>

          {/* Processing Time */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-green-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <Clock className="w-6 h-6 text-green-400" /> Processing Time
            </h2>
            <div className="space-y-3 text-gray-300">
              <p><strong>Cancellation:</strong> Takes effect immediately upon request.</p>
              <p><strong>Refunds:</strong> Processed within 5-7 business days after approval.</p>
              <p><strong>Payment Method:</strong> Refunds are returned to the original payment method.</p>
            </div>
          </div>

          {/* How to Cancel */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-emerald-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <CheckCircle className="w-6 h-6 text-green-400" /> How to Cancel or Request Refund
            </h2>
            <div className="space-y-3 text-gray-300">
              <p><strong>Self-Service:</strong> Cancel anytime through your account settings.</p>
              <p><strong>Customer Support:</strong> Contact us for refund requests or cancellation assistance.</p>
              <p><strong>Email:</strong> support@samamusic.com</p>
              <p><strong>Response Time:</strong> We respond to all requests within 24 hours.</p>
            </div>
          </div>

          {/* Special Circumstances */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-green-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <AlertTriangle className="w-6 h-6 text-green-400" /> Special Circumstances
            </h2>
            <div className="space-y-3 text-gray-300">
              <p><strong>Account Issues:</strong> If you're experiencing technical difficulties, contact support before canceling.</p>
              <p><strong>Billing Disputes:</strong> We work with you to resolve any billing concerns fairly.</p>
              <p><strong>Service Interruptions:</strong> Extended outages may qualify for partial refunds.</p>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}